"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.userClientsErrorSelector = exports.getCurrentUserClientSettingsSelector = exports.getCurrentUserClientSelector = exports.currentUserClientSelector = exports.currentUserClientIdSelector = exports.userClientsSelector = exports.userClientStateSelector = void 0;

var _reselect = require("reselect");

var userStateSelector = function userStateSelector(state) {
  return state.user;
};

var userClientStateSelector = (0, _reselect.createSelector)(userStateSelector, function (user) {
  return user.clients;
});
exports.userClientStateSelector = userClientStateSelector;
var userClientsSelector = (0, _reselect.createSelector)(userClientStateSelector, function (clients) {
  return clients.userClients;
});
exports.userClientsSelector = userClientsSelector;
var currentUserClientIdSelector = (0, _reselect.createSelector)(userClientStateSelector, function (clients) {
  return clients.currentUserClientId;
});
exports.currentUserClientIdSelector = currentUserClientIdSelector;
var currentUserClientSelector = (0, _reselect.createSelector)(userClientStateSelector, function (clients) {
  var _clients$userClients;

  return (_clients$userClients = clients.userClients) === null || _clients$userClients === void 0 ? void 0 : _clients$userClients.find(function (userClient) {
    var _userClient$client;

    return ((_userClient$client = userClient.client) === null || _userClient$client === void 0 ? void 0 : _userClient$client._id) === clients.currentUserClientId;
  });
});
exports.currentUserClientSelector = currentUserClientSelector;
var getCurrentUserClientSelector = (0, _reselect.createSelector)(userClientStateSelector, function (clients) {
  return clients.currentUserClient;
});
exports.getCurrentUserClientSelector = getCurrentUserClientSelector;
var getCurrentUserClientSettingsSelector = (0, _reselect.createSelector)(getCurrentUserClientSelector, function (userClient) {
  return userClient === null || userClient === void 0 ? void 0 : userClient.settings;
});
exports.getCurrentUserClientSettingsSelector = getCurrentUserClientSettingsSelector;
var userClientsErrorSelector = (0, _reselect.createSelector)(userClientStateSelector, function (clients) {
  return clients.error;
});
exports.userClientsErrorSelector = userClientsErrorSelector;
var _default = {
  userClientsSelector: userClientsSelector,
  currentUserClientIdSelector: currentUserClientIdSelector,
  currentUserClientSelector: currentUserClientSelector,
  userClientsErrorSelector: userClientsErrorSelector,
  getCurrentUserClientSelector: getCurrentUserClientSelector,
  getCurrentUserClientSettingsSelector: getCurrentUserClientSettingsSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map